import cx from '@utils/cx.util';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import truckIcon from '@features/pdp/images/icons/icon-truck.svg';

const ProductShipping = ({ freeEconomySubtotal, itemRate, className = '' }) => {
  const stock = useSelector((state: any) => state.pdpItem.details?.stock);
  const shippingInfo = useSelector((state: any) => state.pdpItem.details?.shippingInfo);

  const isPreorder = stock === 'preOrder';

  return (
    <div
      className={cx(
        'tw-flex tw-w-full tw-items-start tw-gap-2 tw-rounded-button tw-border tw-border-neutrals-light-grey tw-p-2',
        className
      )}>
      <div className='tw-flex tw-size-6 tw-shrink-0 tw-items-center tw-justify-center'>
        <img src={truckIcon} alt='truck' className='tw-max-h-full tw-w-full tw-max-w-full' />
      </div>

      {isPreorder ? (
        <div className='tw-flex tw-flex-col'>
          <p className='tw-mb-0 tw-text-sm tw-font-medium tw-leading-none tw-text-brand-black'>Order Now</p>
          <p className='tw-mb-0 tw-text-[13px] tw-font-normal tw-leading-none tw-text-body'>
            Expected to ship by <em>{shippingInfo?.shipDateLocalFormatted}</em>
          </p>
        </div>
      ) : (
        <div className='tw-flex tw-flex-col tw-gap-1'>
          <p className='tw-mb-0 tw-text-sm tw-font-medium tw-leading-none tw-text-brand-black'>
            Free Shipping
          </p>
          <p className='tw-mb-0 tw-text-[13px] tw-font-normal tw-leading-none tw-text-body'>
            {itemRate < freeEconomySubtotal ? `On Orders $${freeEconomySubtotal}+` : 'This item ships free'}
          </p>
        </div>
      )}
    </div>
  );
};

export default memo(ProductShipping);
